<div
    infiniteScroll
    [infiniteScrollContainer]="scrollablePane"
    [infiniteScrollDistance]="3"
    [infiniteScrollThrottle]="50"
    [scrollWindow]="false"
    [immediateCheck]="true"
    [infiniteScrollDisabled]="loadingMoreDeals"
    [alwaysCallback]="true"
    (scrolled)="onScroll()"
>
    <!-- <md-banner-reel
                    *ngIf="!(screenSizeService.isMobileWidth | async)"
                    [categoryId]="sectionId"
                ></md-banner-reel> -->

    <!-- Category deals cards -->
    <div class="md-category-listings">
        <ng-container *ngIf="busyLoadingData">
            <div
                class="md-cat-list-card-wrapper"
                *ngFor="let item of [].constructor(10)"
            >
                <md-product-card-loading></md-product-card-loading>
            </div>
        </ng-container>

        <!-- Iterate through the product listings -->
        <div
            class="md-cat-list-card-wrapper"
            *ngFor="let data of categoryData; let i = index"
        >
            <md-product-card
                [dealEntry]="data"
                (dealSelected)="redirectToProdDetail(data.id, data.productPath)"
            ></md-product-card>
            <!-- Ad Banners Display: Insert banner after specific product index -->
            <div (click)="onParentDivClick($event)">
                <ng-container *ngFor="let banner of bannerMappings">
                    <div
                        *ngIf="
                            banners &&
                            banners[banner.key] &&
                            i === banner.index &&
                            sectionId === banner.sectionId
                        "
                        class="list-banner-content"
                    >
                        <div class="list-banner-container">
                            <ngb-carousel
                                class="custom-carousel"
                                *ngIf="banners[banner.key].images?.length"
                                [activeId]="
                                    'slide-' +
                                    banner.key +
                                    '-' +
                                    banners[banner.key].activeIndex
                                "
                                [showNavigationArrows]="false"
                                [showNavigationIndicators]="false"
                                [interval]="7000"
                                (slide)="onBannerSlide($event, banner.key)"
                            >
                                <ng-template
                                    ngbSlide
                                    *ngFor="
                                        let image of banners[banner.key].images;
                                        let idx = index
                                    "
                                    [id]="'slide-' + banner.key + '-' + idx"
                                >
                                    <img
                                        [src]="
                                            isMobile
                                                ? image.mobile
                                                : image.desktop
                                        "
                                        [alt]="banner.alt"
                                        class="ad-banner-img"
                                        (click)="
                                            handleBannerClick(banner.key, idx)
                                        "
                                    />
                                </ng-template>
                            </ngb-carousel>
                        </div>
                    </div>
                </ng-container>
            </div>

            <!-- Loading more items indicator -->
            <div
                [hidden]="!loadingMoreDeals"
                *ngIf="
                    categoryData.length < totalRecords &&
                    categoryData.length >= 20 &&
                    i + 1 == categoryData.length
                "
            >
                <div class="view_more custom-user-review-div-23">
                    {{ "Loading more" | translate }}
                </div>
            </div>
        </div>
    </div>

    <!-- No products message -->
    <div
        class="md-category-no-product"
        *ngIf="categoryData?.length === 0 && !busyLoadingData"
    >
        {{ "There is no product in selected category" | translate }}
    </div>
    <md-category-all-deals
        #allDeals
        *ngIf="
            categoryData.length === totalRecords &&
            totalRecords < 10 &&
            areFiltersApplied
        "
    />
</div>

<ng-template #bannerTemplate let-banner="banner">
    <div class="col-sm-12" *ngIf="i == 4">
        <swiper
            *ngIf="screenSizeService.isMobileWidth | async; else desktopBanners"
            [config]="bannerConfig"
        >
            <div class="swiper-wrapper">
                <img
                    (click)="goToPromotionLink(img.urlString)"
                    class="swiper-slide"
                    *ngFor="let img of banner"
                    src="assets/img/defaultIcon.png"
                    (error)="onImageError($event)"
                    [src]="img.filename"
                    alt=""
                />
            </div>
        </swiper>
        <ng-template #desktopBanners>
            <swiper [config]="bannerConfig">
                <div class="swiper-wrapper">
                    <img
                        (click)="goToPromotionLink(img.urlString)"
                        class="swiper-slide"
                        *ngFor="let img of banner"
                        src="assets/img/defaultIcon.png"
                        (error)="onImageError($event)"
                        [src]="img.filenameDesktop"
                        alt=""
                    />
                </div>
            </swiper>
        </ng-template>
    </div>
</ng-template>
